import React, { useEffect } from "react";

const GoogleTagManager = () => {
  useEffect(() => {
    // Flag to track if scripts have been loaded
    let scriptsLoaded = false;

    const loadGTM = () => {
      if (scriptsLoaded) return;
      scriptsLoaded = true;

      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js",
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l !== "dataLayer" ? "&l=" + l : "";
        j.defer = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-NZ5WRFG");
    };

    const loadDMCAScript = () => {
      if (scriptsLoaded) return;
      scriptsLoaded = true;
      const script = document.createElement("script");
      script.src = "https://images.dmca.com/Badges/DMCABadgeHelper.min.js";
      script.defer = true;
      document.body.appendChild(script);
    };

    const loadClarity = () => {
      if (scriptsLoaded) return;
      scriptsLoaded = true;
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
        t = l.createElement(r);
        t.async = true;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", "npsb5wlyvz");
    };

    const loadScripts = () => {
      if (scriptsLoaded) return;
      console.log("User interaction detected, loading scripts...");
      loadGTM();
      loadDMCAScript();
      loadClarity();
      console.log("Scripts loaded!");

      // Remove event listeners after loading scripts
      document.removeEventListener("mousedown", loadScripts);
      document.removeEventListener("mousemove", loadScripts);
      document.removeEventListener("touchstart", loadScripts);
      document.removeEventListener("keydown", loadScripts);
      document.removeEventListener("click", loadScripts);
      document.removeEventListener("scroll", loadScripts);
    };

    // Set up event listeners for user interaction
    const events = [
      "mousedown",
      "mousemove",
      "touchstart",
      "keydown",
      "click",
      "scroll",
    ];

    events.forEach((event) => {
      document.addEventListener(event, loadScripts);
    });

    // Fallback timeout to load scripts after 10 seconds if no user interaction
    const timer = setTimeout(() => {
      if (!scriptsLoaded) {
        console.log(
          "No user interaction detected, loading scripts after timeout..."
        );
        loadGTM();
        loadDMCAScript();
        loadClarity();
      }
    }, 10000);

    return () => {
      // Cleanup: Remove event listeners and clear timeout
      clearTimeout(timer);
      events.forEach((event) => {
        document.removeEventListener(event, loadScripts);
      });
    };
  }, []); // Empty dependency array means this effect runs only once

  return (
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-NZ5WRFG"
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
      ></iframe>
    </noscript>
  );
};
export default GoogleTagManager;

// const GoogleTagManager = () => {
//   useEffect(() => {
//     // Check if GTM has already been loaded to prevent duplicate loading
//     if (window.hasLoadedGTM) return;

//     const loadGTM = () => {
//       // Mark GTM as loaded
//       window.hasLoadedGTM = true;

//       (function (w, d, s, l, i) {
//         w[l] = w[l] || [];
//         w[l].push({
//           "gtm.start": new Date().getTime(),
//           event: "gtm.js",
//         });
//         var f = d.getElementsByTagName(s)[0],
//           j = d.createElement(s),
//           dl = l !== "dataLayer" ? "&l=" + l : "";
//         j.defer = true;
//         j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
//         f.parentNode.insertBefore(j, f);
//       })(window, document, "script", "dataLayer", "GTM-NZ5WRFG");
//     };

//     const loadDMCAScript = () => {
//       const script = document.createElement("script");
//       script.src = "https://images.dmca.com/Badges/DMCABadgeHelper.min.js";
//       script.defer = true;
//       document.body.appendChild(script);
//     };

//     const loadClarity = () => {
//       (function (c, l, a, r, i, t, y) {
//         c[a] =
//           c[a] ||
//           function () {
//             (c[a].q = c[a].q || []).push(arguments);
//           };
//         t = l.createElement(r);
//         t.async = true;
//         t.src = "https://www.clarity.ms/tag/" + i;
//         y = l.getElementsByTagName(r)[0];
//         y.parentNode.insertBefore(t, y);
//       })(window, document, "clarity", "script", "npsb5wlyvz");
//     };

//     // Function to load GTM, DMCA, and Clarity scripts 5 seconds after user interaction
//     const loadScriptsOnUserInteraction = () => {
//       // Remove event listeners to ensure this runs only once
//       document.removeEventListener("click", loadScriptsOnUserInteraction);
//       document.removeEventListener("scroll", loadScriptsOnUserInteraction, {
//         passive: true,
//       });
//       // Use a timeout to delay the GTM, DMCA, and Clarity script load by 5 seconds after an interaction
//       setTimeout(() => {
//         loadGTM();
//         loadDMCAScript();
//         loadClarity();
//       }, 10000);
//     };

//     // Set up event listeners for user interaction
//     document.addEventListener("click", loadScriptsOnUserInteraction);
//     document.addEventListener("scroll", loadScriptsOnUserInteraction, {
//       passive: true,
//     });

//     // Also set a timer to load scripts after 10 seconds if no interaction occurs
//     const timer = setTimeout(() => {
//       loadGTM();
//       loadDMCAScript();
//       loadClarity();
//     }, 10000);

//     return () => {
//       // Cleanup both the event listeners and the timer when the component unmounts
//       clearTimeout(timer);
//       document.removeEventListener("click", loadScriptsOnUserInteraction);
//       document.removeEventListener("scroll", loadScriptsOnUserInteraction);
//     };
//   }, []);

//   return (
//     <>
//       <noscript>
//         <iframe
//           src="https://www.googletagmanager.com/ns.html?id=GTM-NZ5WRFG"
//           height="0"
//           width="0"
//           style={{ display: "none", visibility: "hidden" }}
//         ></iframe>
//       </noscript>
//     </>
//   );
// };

// export default GoogleTagManager;
